import React from "react";
import "../Contact/Contact.css";
import { Box,styled, Tooltip, tooltipClasses, Button} from "@mui/material";

import twitter from "../Images/twitter_logo.png"
import linkedin from "../Images/linkedin_logo.png"
import github from "../Images/github_logo.png"


export const Contact = () => {



        const copyEmail = () => {
            navigator.clipboard.writeText("ParagTharani24@gmail.com");
        }

        const BootstrapTooltip = styled(({ className, ...props }) => (
            <Tooltip {...props} arrow classes={{ popper: className }} />
          ))(({ theme }) => ({
            [`& .${tooltipClasses.arrow}`]: {
              color: theme.palette.common.black,
            },
            [`& .${tooltipClasses.tooltip}`]: {
              backgroundColor: theme.palette.common.black,
              fontSize:"1.15vw",
            },
          }));



    return (
        <>
        <Box className="contactPage" id="Contact">

          {/* <Box className="form">
          
          </Box> */}


          <Box sx={{width:"50%", margin:"auto"}}>
            <h1 style={{fontSize:"7vw", margin:0,marginTop:"10vh", marginBottom:"10vh"}}>Let's Connect @</h1>

            <p onClick={() => copyEmail()}  className="email" style={{fontSize:"5vw",width:"70vw", margin:0, marginBottom:"0vh", cursor:"pointer"}}><b>Email :</b> 
            <BootstrapTooltip title="Click to Copy Email">
            <Button variant="text" sx={{fontSize:"3vw", fontFamily:"'Aladin', cursive;", marginLeft:"2vw", cursor:"pointer", color:"hsl(316, 30%, 36%)" }}>ParagTharani24@gmail.com</Button>
            </BootstrapTooltip>
            </p>
            <Box sx={{display:'flex', alignItems:'center',height:"20vh", margin:0}}>
                <p style={{fontSize:"5vw"}}><b>Socials :</b></p>
                <a href="https://twitter.com/ParagTharani_24" target="_blank" rel="noreferrer"><img alt="Twitter Logo" style={{width:"5vw",marginLeft:"2vw", borderRadius:"100px", backgroundColor:"hsl(316, 30%, 36%)"}} src={twitter} /></a>
                <a href="https://linkedin.com/in/parag-tharani" target="_blank" rel="noreferrer"><img alt="Twitter Logo" style={{width:"5vw",marginLeft:"1.5vw", borderRadius:"100px", backgroundColor:"hsl(316, 30%, 36%)"}} src={linkedin} /></a>
                <a href="https://github.com/parag-tharani" target="_blank" rel="noreferrer"><img alt="Twitter Logo" style={{width:"4.6vw",marginLeft:"1.5vw", borderRadius:"100px", backgroundColor:"hsl(316, 30%, 36%)"}} src={github} /></a>
            </Box>
            </Box>

            {/* <p style={{position:"relative", marginTop:"20vh"}}>@2002. All Right Reserved by God.</p> */}
        </Box>
        </>
    )
}